import { render, staticRenderFns } from "./ApplicationSubmissionItem.vue?vue&type=template&id=24aa4592&scoped=true&"
import script from "./ApplicationSubmissionItem.vue?vue&type=script&lang=js&"
export * from "./ApplicationSubmissionItem.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSubmissionItem.vue?vue&type=style&index=0&id=24aa4592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa4592",
  null
  
)

export default component.exports